import { render, staticRenderFns } from "./optimiserSheet.vue?vue&type=template&id=06b34ff8&"
import script from "./optimiserSheet.vue?vue&type=script&lang=js&"
export * from "./optimiserSheet.vue?vue&type=script&lang=js&"
import style0 from "./optimiserSheet.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports